export default __webpack_public_path__ + "static/customer-support-bg-900de3515e99103d355b62008c1370a9.png";